@use "variables" as *;

.description {
  margin-bottom: $spacing-s;
}

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
  width: 96%;
}

.calculateButton {
  float: left;
}
